module.exports = __webpack_public_path__ + "img/c4.f9737f8d.png";